import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { Observable, Subscription } from 'rxjs';
import { UIActions } from 'src/app/core/store/actions/ui/actions';
import { AppState } from 'src/app/core/store/app.reducers';
import _get from 'lodash/get';
import { selectTopBarTitle } from '@app-core/store/selectors/topbar.selectors';

@Component({
  selector: 'app-sidebar-top',
  templateUrl: './sidebar-top.component.html',
  styleUrls: ['./sidebar-top.component.scss'],
})
export class SidebarTopComponent implements OnInit, OnDestroy {
  subscription: Subscription = new Subscription();
  sidebarToggle: boolean;

  @Input() logo = '/assets/images/logos/LSS_Logo.svg';
  customerLogo = '../../../../assets/images/logos/LSS_LogoSmall.svg';
  customerLogoLarge = '../../../../assets/images/logos/LSS_Logo.svg';
  showSidebar: boolean;
  sidebarOpen: boolean;

  titleLabel$: Observable<string>;
  constructor(private store: Store<AppState>) {
    this.logo = '/assets/images/logos/LSS_LogoSmall.svg';
  }

  ngOnInit(): void {
    this.subscription = this.store.select('ui').subscribe((event) => {
      if (event.sidebarOpen == 'mouseout') {
        this.sidebarToggle = false;
      } else if (event.sidebarOpen == 'mouseopen') {
        this.sidebarToggle = false;
      } else if (event.sidebarOpen == 'open') {
        this.sidebarToggle = true;
      } else {
        this.sidebarToggle = false;
      }
    });
    this.titleLabel$ = this.store.select(selectTopBarTitle);
  }

  toggleSideNav() {
    if (!this.sidebarToggle) {
      this.store.dispatch({
        type: UIActions.UI_SIDEBAR_SET_STATE,
        payload: 'open',
      });
    } else {
      this.store.dispatch({
        type: UIActions.UI_SIDEBAR_SET_STATE,
        payload: 'close',
      });
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
